<template>
  <Transition name="planning-legend-fade">
    <div v-if="legend" class="planning-legend" data-testid="planning-legend">
      <img :src="legend.dataUrl" :width="displayWidth" :height="displayHeight" alt="" />
    </div>
  </Transition>
</template>

<script setup>
  import { computed } from 'vue'
  import { PLANNING_LEGEND_DISPLAY_SCALE, PLANNING_LEGEND_RENDER_SCALE } from '@/constants'

  // RED-293 round 3: the maakasutus legend for the current viewport, floating
  // over the Planeeringud map. Same rows the Word report places beside
  // ${kaart-planeeringud}, rendered PLANNING_LEGEND_RENDER_SCALE times larger
  // and shown PLANNING_LEGEND_DISPLAY_SCALE times the docx size (round 6:
  // bigger, readable, crisp on HiDPI). MapComponent.exportMap() copies
  // OpenLayers canvases only, so this panel never lands in the export.
  const { legend } = defineProps({
    legend: { type: Object, default: null },
  })

  const displayPx = px => Math.max(1, Math.round((px * PLANNING_LEGEND_DISPLAY_SCALE) / PLANNING_LEGEND_RENDER_SCALE))
  const displayWidth = computed(() => (legend ? displayPx(legend.widthPx) : 0))
  const displayHeight = computed(() => (legend ? displayPx(legend.heightPx) : 0))
</script>

<style scoped>
  @reference '../../../../css/tailwind.css';

  .planning-legend {
    position: absolute;
    right: 12px;
    bottom: 28px;
    z-index: 1;
    pointer-events: none;
    max-width: 50%;
    @apply rounded-md border border-gray-200/70 bg-white/70 p-2.5 shadow-sm backdrop-blur-sm dark:border-gray-700/70 dark:bg-gray-800/70;
  }
  .planning-legend img {
    display: block;
    max-width: 100%;
    height: auto;
  }
  .planning-legend-fade-enter-active,
  .planning-legend-fade-leave-active {
    transition: opacity 0.25s ease;
  }
  .planning-legend-fade-enter-from,
  .planning-legend-fade-leave-to {
    opacity: 0;
  }
</style>
